<template>
  <div id="detail" class="detail">
    <!-- <div class="back" @click="back"><img src="./img/backup.png" alt=""><span>返回上一页</span></div> -->
   
    <img style="width:100%" src="@/assets/serviceImg/gjfw1 (1).png">
    <div class="rich_text" style="margin-bottom: 3vw;">
      {{ butlerCopyText }}
    </div>
    <!-- <b style="color:#333333;font-weight: 500;font-size: 1rem;">星使服务说明</b>
    <div class="rich_text" style="margin-top: 3vw;">
      大救星平台提供全天候24小时星使服务，星使是长期生活或工作在当地的人员，熟悉当地环境，能够讲当地语言和中文。星使实名注册且经过培训后，由星使为用户提供各类线上咨询、线下以及代办代理等服务。例如陪同就医、住院陪同、陪同翻译等等。星使的服务费用需用户另行支付。
    </div> -->
    <div
      class="add"
      :class="{ 'add--disabled': !equityCanUse }"
      style="width: 100%;height: 11vw;background: rgb(0, 187, 130);border-radius: 20px;text-align: center;line-height: 11vw;color: #ffffff;font-size: 4vw;display: flex;align-items: center;justify-content: center;"
      @click="actionCallHelp()"
    >{{ getServiceBtnText }}</div>
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p style="margin-bottom: 7vw;">该项权益需开通以下服务权益</p>
        <div style="width:100%;height:40vw;position: relative;" @click="equity()">
          <img style="width: 100%;height: 100%;position: absolute;top: 2vw;" src="@/assets/img/qykbj.png" />
          <div>
             <h3 style="position: absolute;top: 17vw;left: 7vw;font-size: 5vw;">大救星-星健康权益卡</h3>
             <div style="position: absolute;top: 25vw;left: 7vw;color:#666666;font-size: 3.5vw;">多项健康权益尊享，为您健康守护</div>
             <div style="width: 18vw;height: 7vw;font-size: 3vw;line-height: 7vw;color: #F2D57A;text-align: center;background: rgb(74, 71, 64);border-radius: 16px;position: absolute;top: 17vw;right: 4vw;">了解更多</div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
import Axios from 'axios'
import { getTaiheServiceCopy } from '@/utils/taiheServiceCopy';
import equityUsedCountMixin from '@/mixins/equityUsedCountMixin'

export default {
  equityServiceKey: 'butlerservice',
  mixins: [equityUsedCountMixin],
  data () {
    return {
      attribute:'',
      src1:'',
      detailText: '',
      showModal:false,
      equityinfoType:false,
    };
  },
  computed: {
    /**
     * 根据 productId 显示安全管家服务页面文案
     * @returns {string}
     */
    butlerCopyText() {
      const productId = this.$route.query.productId;
      if (productId === '947' || productId === 947) {
        return '大救星可为用户提供包含星使服务、紧急医疗咨询、紧急信息传递、协助呼叫救护车、医疗机构推荐、照顾老年人、遗失行李或文件援助、应急现金协调、安保服务、法律援助、紧急撤离、境内外体检、二次诊疗、处方援助、接送机等服务的免费咨询和推介，由此产生的第三方费用需由用户承担。';
      }
      const defaultCopy = '提供包含星使服务、紧急医疗咨询、医疗监护、紧急信息传递、遗失行李或文件援助、安保服务、紧急创伤咨询 、保释协调、处方援助、应急现金协调、法律援助 、协助安排境外旅行机构 、照顾老年人 、紧急撤离 、境内外体检 、二次诊疗 、接送机 、医疗出诊 、商务翻译 、会议场地 、危机公关处理 、医疗陪同 、补办证件陪同及报案陪同等24项服务的免费咨询和推介，由此产生的第三方实际费用需由用户承担。';
      return getTaiheServiceCopy(productId, 'butlerservice', defaultCopy);
    }
  },
  created(){
    this.equityinfoType = localStorage.getItem('equityinfo');
  },
  mounted() {
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "48px";
        }
  },
  beforeCreate() {
    document.title = "安全管家服务"
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F2F3F5");
  },
  methods: {
    /**
     * 获取服务：校验剩余次数后跳转一键救援
     */
    actionCallHelp() {
      this.goRescueWithCaseType()
    },
    equity() {
      this.$router.push({
              path: "/equity",
              query:{
              }
            });
    }
    // detail(){
    //   Axios({
    //     params:{
    //       id:this.$route.query.id
    //     },
    //     // util.config.api
    //     methods:'post',
    //     baseURL: 'https://api.dajiuxing.com.cn',
    //     url: '/1.0/news/news-info'
    //   }).then(res=>{
    //     console.log(res,'详情详情');
    //     this.detailText = res.data.obj;
    //     this.attribute = res.data.obj.attribute
    //     if(res.data.obj.attribute == 3) {
    //       this.src1 = res.data.obj.url
    //     }else {
    //       this.src1 = res.data.obj.pic
    //     }
       
    //   }).catch(error=>{
    //     console.log(error)
    //   })
    // },
    
  }
}
</script>
<style scoped >
.modal {
   
   position: fixed; 
   z-index: 1000000; 
   left: 0;
   top: 0;
   width: 100%; 
   height: 100%; 
   overflow: auto; 
   background-color: rgb(0,0,0); 
   background-color: rgba(0,0,0,0.4); 
 }
 .modal-content {
   background-color: #fefefe;
   padding: 8% 5%;
   border-radius: 12px 12px 0px 0px;
   position: absolute;
   bottom: 0;
   width: 100%;
   line-height: 0;
 }
 .close {
   color: #aaa;
   float: right;
   font-size: 28px;
   font-weight: bold;
 }
 .close:hover,
 .close:focus {
   color: black;
   text-decoration: none;
   cursor: pointer;
 }
  .title{
    line-height: 2rem;
    text-align: center;
    margin: 1rem 0;
    border-bottom: none;
    padding: 0;
  }
  h5{
    /* font-size: 1.04166vw; */
    font-weight: normal;
    margin-bottom: 1.04166vw;
  }   
  .rich_text {
    text-indent: 2em;
    width:100%;
    word-wrap: break-word;
  }
  .rich_text >>> img{
    width: 100%;
  }
  .back{
    cursor: pointer;
    margin-bottom: 1.04166vw;
  }
  img{
    width: 1.145833vw;
    /* height: 0.98958333vw; */
    vertical-align: middle;
    margin-right: .5vw;
    margin-bottom: 1rem;
  }
  .rich_text, .rich_text span, .rich_text p, .rich_text strong{
    font-size: 14px!important;
    color: #666!important;
    /* line-height: 1.5rem!important; */
  }
  .detail{
    padding: 1rem 1rem 2rem;
    width: 100%;
    height: auto;
    overflow-x: hidden;
  }
  .add {
    margin-top:200px;
  }
  .add--disabled {
    opacity: 0.55;
    pointer-events: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/detailsH5/butlerservice.vue